// @flow
import AddChild from './AddChild';
import withChildAddPermission from './withChildAddPermission';
import AddChildButton from './AddChildButton';

export default AddChild;
export { withChildAddPermission, AddChildButton };
